 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/text/cover'
 import TEXTTITLE_PAGE from '@/components/text/title_page'
 import NAV from '@/components/nav'
 import TEXTCH001 from '@/components/text/ch001'
 import TEXTCH002 from '@/components/text/ch002'
 import TEXTCH003 from '@/components/text/ch003'
 import TEXTCH004 from '@/components/text/ch004'
 import TEXTCH005 from '@/components/text/ch005'
 import TEXTCH006 from '@/components/text/ch006'
 import TEXTCH007 from '@/components/text/ch007'
 import TEXTCH008 from '@/components/text/ch008'
 import TEXTCH009 from '@/components/text/ch009'
 import TEXTCH010 from '@/components/text/ch010'
 import TEXTCH011 from '@/components/text/ch011'
 import TEXTCH012 from '@/components/text/ch012'
 import TEXTCH013 from '@/components/text/ch013'
 import TEXTCH014 from '@/components/text/ch014'
 import TEXTCH015 from '@/components/text/ch015'
 import TEXTCH016 from '@/components/text/ch016'
 import TEXTCH017 from '@/components/text/ch017'
 import TEXTCH018 from '@/components/text/ch018'
 import TEXTCH019 from '@/components/text/ch019'
 import TEXTCH020 from '@/components/text/ch020'
 import TEXTCH021 from '@/components/text/ch021'
 import TEXTCH022 from '@/components/text/ch022'
 import TEXTCH023 from '@/components/text/ch023'
 import TEXTCH024 from '@/components/text/ch024'
 import TEXTCH025 from '@/components/text/ch025'
 import TEXTCH026 from '@/components/text/ch026'
 import TEXTCH027 from '@/components/text/ch027'
 import TEXTCH028 from '@/components/text/ch028'
 import TEXTCH029 from '@/components/text/ch029'
 import TEXTCH030 from '@/components/text/ch030'
 import TEXTCH031 from '@/components/text/ch031'
 import TEXTCH032 from '@/components/text/ch032'
 import TEXTCH033 from '@/components/text/ch033'
 import TEXTCH034 from '@/components/text/ch034'
 import TEXTCH035 from '@/components/text/ch035'
 import TEXTCH036 from '@/components/text/ch036'
 import TEXTCH037 from '@/components/text/ch037'
 import TEXTCH038 from '@/components/text/ch038'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/nav",
 			"name" : "nav",
 			"component" : NAV
 		},
 		{
 			"path" : "/text/ch001",
 			"name" : "text/ch001",
 			"component" : TEXTCH001
 		},
 		{
 			"path" : "/text/ch002",
 			"name" : "text/ch002",
 			"component" : TEXTCH002
 		},
 		{
 			"path" : "/text/ch003",
 			"name" : "text/ch003",
 			"component" : TEXTCH003
 		},
 		{
 			"path" : "/text/ch004",
 			"name" : "text/ch004",
 			"component" : TEXTCH004
 		},
 		{
 			"path" : "/text/ch005",
 			"name" : "text/ch005",
 			"component" : TEXTCH005
 		},
 		{
 			"path" : "/text/ch006",
 			"name" : "text/ch006",
 			"component" : TEXTCH006
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js